module.exports = __webpack_public_path__ + "static/media/tdsScotland.88d1045b.png";